import { DataTableColumn } from 'components/tables/data-table';

export const getRowName = (row: any, col: DataTableColumn) => {
  return row?.[col.field]?.['name'];
};

export const bookingActivityDataColumns: DataTableColumn[] = [
  {
    width: 80,
    field: 'timestamp',
    label: 'DATE',
    type: 'dateTime',
    getValueLabel: v =>
      !!v ? new Date(v).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' }).replace(',', '') : null
  },
  {
    width: 80,
    field: 'action',
    label: 'ACTION'
  },
  {
    width: 80,
    field: 'modifiedBy',
    label: 'USER'
  },
  {
    width: 80,
    field: 'description',
    label: 'DESCRIPTION'
  }
];
